import Modal from "CKJS/format/modal"
import SlideIn from "CKJS/format/slide-in"
import Inline from "CKJS/format/inline"

export { Modal, SlideIn, Inline }
